import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { StateTaxExemption } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-state-tax-exemption-dialog',
    templateUrl: './state-tax-exemption-dialog.component.html',
    styleUrls: ['./state-tax-exemption-dialog.component.scss'],
    standalone: false
})
export class StateTaxExemptionDialogComponent implements OnInit {
    result = new Subject<{ success: boolean; stateTaxExemption?: StateTaxExemption }>();
    stateTaxExemption: StateTaxExemption;
    displayOrder: number;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.stateTaxExemption) {
            this.stateTaxExemption = this.uow.stateTaxExemptions.createEntity({
                displayOrder: this.displayOrder,
            }) as StateTaxExemption;
        }
    }

    async save() {
        const success = this.validate();
        console.log('success', success)
        if (!success) return;

        await this.uow.commit([this.stateTaxExemption]);
        this.result.next({ success: true, stateTaxExemption: this.stateTaxExemption });
    }

    close() {
        this.stateTaxExemption.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('stateTaxExemptionValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('stateTaxExemptionValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
